import {
  DatePickerWithInput,
  ModalLayout,
  NavGroup,
  Pagination,
  SearchFilters,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import { Link } from "react-router-dom";
import Style from "../../../Billings/staffBilling.module.scss";
import { Table } from "../../../Global/Table";
import CashReceiptForm from "../CashReceiptForm";
import SupplierPaymentForm from "../SupplierPaymentForm";
import ReceiptPdf from "../Print/ReceiptPdf";
import usePending from "./usePending";

const Pending = () => {
  const {
    paginationOptions,
    isInvoices,
    subTabNavs,
    reduxState,
    queryState,
    currentData,
    isFetching,
    isLoading,
    tableFields,
    receiptRef,
    date,
    getRow,
    handleDateChange,
    handleSearch,
    handleSort,
    handlePageSize,
    handlePagination,
    handleOpenReceiptModal,
    handleCloseReceiptModal,
    handleOpenSupplierModal,
    handleCloseSupplierModal,
    triggerReceiptPrint,
  } = usePending();

  return (
    <>
      <div className={`${Style.main_container}`}>
        <NavGroup navigations={subTabNavs} type={"type-2"} Link={Link} />
      </div>

      <div className="col-auto pro-pt-3">
        <SearchFilters
          onSearchInput={handleSearch}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={false}
          searchInputProps={{
            value: queryState?.search,
            placeholder: "Search this table",
          }}
          showActions={false}
          loading={isLoading}
          filterChildren={
            <div className="col-auto">
              <div className="pro-d-flex pro-items-center pro-gap-2">
                <DatePickerWithInput
                  CalendarOutlineIcon={
                    <span className="material-symbols-outlined">
                      calendar_month
                    </span>
                  }
                  range={true}
                  initialValue={date}
                  onDateChange={handleDateChange}
                />
              </div>
            </div>
          }
        />
      </div>

      <Table
        key={isInvoices ? "invoices" : "supplier"}
        multiSelect={isInvoices}
        data={currentData?.data?.data || []}
        uniqueID={"_id"}
        fields={tableFields}
        SortIcon={<FaSort />}
        handleSort={handleSort}
        getRow={getRow}
        loading={isFetching}
        perpage={queryState?.currentPageSize}
        assignable={true}
        assignText={"Slip"}
        assignIcon={<span className="material-symbols-outlined">print</span>}
        handleAssign={
          isInvoices ? handleOpenReceiptModal : handleOpenSupplierModal
        }
        showCheckBox={true}
        editable={false}
        deletable={false}
        clear={queryState?.clear}
      />
      {currentData?.data?.data?.length > 0 && (
        <Pagination
          currentPage={queryState?.currentPage}
          totalPageCount={Math.ceil(
            currentData?.data?.total_count / queryState?.currentPageSize,
          )}
          onPageChange={handlePagination}
          options={paginationOptions}
          onActionChange={handlePageSize}
          center
        />
      )}

      <ModalLayout
        show={reduxState?.showReceiptModal}
        handleClose={handleCloseReceiptModal}
        backdrop="static"
      >
        <CashReceiptForm
          onClose={handleCloseReceiptModal}
          onPrintReady={triggerReceiptPrint}
        />
      </ModalLayout>

      <ModalLayout
        show={reduxState?.showSupplierModal}
        handleClose={handleCloseSupplierModal}
        backdrop="static"
      >
        <SupplierPaymentForm
          onClose={handleCloseSupplierModal}
          onPrintReady={triggerReceiptPrint}
        />
      </ModalLayout>

      <div
        style={{
          position: "fixed",
          opacity: "0",
          visibility: "hidden",
          height: "0",
          width: "0",
        }}
      >
        <ReceiptPdf receiptRef={receiptRef} />
      </div>
    </>
  );
};

export default Pending;
